import React, { FC } from 'react';

type Breadcrumb = {
  id: string;
  label: string;
  url: string;
};

interface BreadcrumbsProps {
  brandName?: string;
  breadcrumbsList: Breadcrumb[];
  gridArea?: string;
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ brandName, breadcrumbsList, gridArea }) => {
  return (
    <div className="breadcrumbs-row desktop-flex">
      {breadcrumbsList.map((bc, index) => (
        <>
          {bc.url ? (
            <a className="breadcrumbs-link" data-cy={`link-breadcrumb-${bc.label.toLowerCase()}`} href={bc.url}>
              {bc.label}
            </a>
          ) : (
            <span className="breadcrumbs-text">{bc.label}</span>
          )}
          {index < breadcrumbsList.length - 1 && <span className="breadcrumbs-separator">&gt;</span>}
        </>
      ))}
      {brandName && (
        <div>
          <span className="breadcrumbs-separator">&gt;</span>
          <span className="breadcrumbs-text">{brandName}</span>
        </div>
      )}
      <style jsx>
        {`
          .breadcrumbs-row {
            width: 100%;
            align-items: center;
            grid-area: ${gridArea};
            margin-top: 15px;
          }

          .breadcrumbs-link {
            font-family: 'Avenir Light', 'Arial', sans-serif;
            font-size: 15px;
            color: #999;
            font-weight: 400;
            display: inline;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            text-transform: capitalize;
          }

          .breadcrumbs-separator {
            color: #000;
            font-weight: 700;
            margin: 0 5px;
            font-size: 13px;
          }

          .breadcrumbs-text {
            font-family: 'Avenir Light', 'Arial', sans-serif;
            font-size: 15px;
            color: #999;
            font-weight: 400;
            display: inline;
            height: 20px;
            line-height: 20px;
          }
        `}
      </style>
    </div>
  );
};

export { Breadcrumbs };
